import { HexMap } from "../../../Data/HexMap/HexMap"
import { useNoteNames } from "../../../Project/ProjectStore"

export function CommonNotes(props:{map:HexMap, noteIndexes:number[]}){
    const noteNames:string[] = useNoteNames()
    const getUniqueNotes = () => {
        const commonNoteNames:string[] = props.noteIndexes.map(
            (noteIndex:number)=>{
                const tonic:number = props.map.notes[noteIndex].params.tonic
                return noteNames[tonic]
            }
        )
        const uniqueCommonNotes = Array.from(new Set(commonNoteNames))
        return uniqueCommonNotes.sort()
    }
    const NoteName = (props:{name:string, index:number}) => {
        const comma:string = (props.index === 0) ? '' : ', '
        return <span className={'common-note'}>{comma}{props.name}</span>
    }
    return(
        <span className={'common-notes'}>
        [
            {getUniqueNotes().map(
                (noteName:string, index:number)=>{ 
                    return <NoteName name={noteName} index={index}/>
                }
            )}
        ]
        </span>
    )
}